var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{staticClass:"mb-32",attrs:{"cols":"12"}},[_c('page-content',{attrs:{"breadcrumbTitle":true,"breadcrumb":[
        {
          title: 'Pages',
        },
      ]}})],1),_c('b-col',{staticClass:"mb-32",attrs:{"cols":"12"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }